import { type ReactElement } from 'react';
import {
    CredentialRotationRecoverySeverity,
    type PortalCredentialRotationRecoverySummary,
} from '@anchorbase/pillar-sdk';
import { Alert, AlertDescription } from '@/components/ui/alert';

const RECOVERY_SEVERITY_COPY: Record<
    CredentialRotationRecoverySeverity,
    string
> = {
    [CredentialRotationRecoverySeverity.INFO]: 'Info',
    [CredentialRotationRecoverySeverity.WARNING]: 'Warning',
    [CredentialRotationRecoverySeverity.ERROR]: 'Error',
};

export interface IpxCredentialRecoveryNoticeProps {
    readonly recoverySummary: PortalCredentialRotationRecoverySummary | null;
}

export function IpxCredentialRecoveryNotice(
    props: IpxCredentialRecoveryNoticeProps
): ReactElement | null {
    if (props.recoverySummary === null) {
        return null;
    }
    return (
        <Alert>
            <AlertDescription>
                {RECOVERY_SEVERITY_COPY[props.recoverySummary.severity]}:{' '}
                {props.recoverySummary.message}
            </AlertDescription>
        </Alert>
    );
}
